module.exports = __webpack_public_path__ + "static/media/roseconstruction.9304f317.png";